webpackJsonp([130732907663140],{

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Assets;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _MediaThreeColImages = __webpack_require__(208);
	
	var _MediaThreeColImages2 = _interopRequireDefault(_MediaThreeColImages);
	
	var _assets = __webpack_require__(121);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Assets() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'top' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'padding', sizeM: 'xl', position: 'topBottom' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 'l' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { type: 'padding', size: 'xl', position: 'bottom' },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: 769 },
	            _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.assetsFallback, { hasShadow: false }))
	          ),
	          _react2.default.createElement(_HeadingBlock2.default, {
	            size: 'xs',
	            justifyContent: 'center',
	            justifyM: 'start',
	            title: 'Instantly turn designs into code, specs and assets',
	            copy: _react2.default.createElement(
	              'span',
	              null,
	              'Our design handoff tool, puts an end to manual design documentation, PDFs and redlines. Now, all you need for designer developer handoff is a single URL, where they can find everything they need to start building.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'Handoff generates CSS, Swift and Android XML instantly for designs made within Marvel or Sketch, shaving time off the design to development process.'
	            )
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: 770 },
	        _react2.default.createElement(_MediaThreeColImages2.default, {
	          radius: 'none',
	          images: _assets2.default.assetsBlock,
	          fallbackImage: _assets2.default.assetsFallback
	        })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-handoff-assets-js-c92797b257b66f142d82.js